import { Route } from 'vue-router';

export default [{
  path: '/appHelper',
  name: 'AppHelper',
  component: () => import(/* webpackChunkName: "appHelper" */ '../views/appHelper/Index.vue'),
  redirect: { name: 'AppUniversal' },
  meta: {
    title: '关于我们',
  },
  children: [
    {
      path: '/appHelper/deviceInfo',
      name: 'AppHelper.deviceInfo',
      component: () => import(/* webpackChunkName: "appHelper.deviceInfo" */ '../views/appHelper/DeviceInfo.vue'),
      meta: {
        title: '设备检测',
      },
    },
    {
      path: '/about/go',
      name: 'AboutGo',
      component: () => import(/* webpackChunkName: "about.go" */ '../views/appHelper/AboutGo.vue'),
    },
    {
      path: '/about/coding',
      name: 'AboutCoding',
      component: () => import(/* webpackChunkName: "about.coding" */ '../views/appHelper/AboutCoding.vue'),
    },
    {
      path: '/about/vip',
      name: 'AboutVip',
      component: () => import(/* webpackChunkName: "about.vip" */ '../views/appHelper/AboutVip.vue'),
    },
    {
      path: '/appHelper/download',
      name: 'AppDownload',
      component: () => import(/* webpackChunkName: "appHelper.download" */ '../views/appHelper/AppDownload.vue'),
      meta: {
        title: '下载有道卡搭',
      },
      props: (route: Route) => ({
        type: route.query.type,
      }),
    },
    {
      path: '/appHelper/universal',
      name: 'AppUniversal',
      component: () => import(/* webpackChunkName: "appHelper.universal" */ '../views/appHelper/AppUniversal.vue'),
      meta: {
        title: '下载有道卡搭',
      },
    },
    {
      path: '/appHelper/sweep',
      name: 'Sweep',
      component: () => import(/* webpackChunkName: "appHelper.sweep" */ '../views/appHelper/Sweep.vue'),
      meta: {
        title: '有道卡搭检测页',
      },
    },
    {
      path: '/appHelper/exchangeSuccess',
      name: 'AppExchangeSuccess',
      component: () => import(/* webpackChunkName: "appHelper.exchangeSuccess" */ '../views/appHelper/AppExchangeSuccess.vue'),
      meta: {
        title: '兑换成功',
      },
      props: (route: Route) => ({
        type: route.query.type,
      }),
    },
  ],
}];
